import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { BaseDocumentsService } from "../../shared/cerrix-documents/services/base-documents.service";
import { IncidentDocumentTypeService } from "./incident-document-type.service";
import { DocumentMethods } from "@methods/DocumentMethods";
import { DocumentDataService } from "@services/http/document/DocumentDataService";
import { ToastrService } from "ngx-toastr";
import { TabService } from "@services/tabs/TabService";
import { Pages } from "@constants/pages/Pages";
import { PopupService } from "@app/shared/services/popup/popup.service";
import { HttpClient } from "@angular/common/http";
import { SelectOptionModel } from "../components/src/lib/core/models/select-option.model";

@Injectable({
    providedIn: "root",
})
export class IncidentDocumentsService extends BaseDocumentsService {
    private documentTypeService = inject(IncidentDocumentTypeService);
    private documentDataService = inject(DocumentDataService);
    private toastrService = inject(ToastrService);
    private tabService = inject(TabService);
    private pages = inject(Pages);
    private _popupService = inject(PopupService);
    private httpClient: HttpClient = inject(HttpClient);
    private baseUrl = `${localStorage.getItem("incidentUrl")}/api/incidents/documents`;

    getDocumentTypes(): Observable<SelectOptionModel[]> {
        return this.documentTypeService.getAll();
    }

    getDocumentIcon(fileName: string): string {
        return DocumentMethods.getDocumentIcon(fileName);
    }

    getDocumentConfig(): Observable<{ maxUploadSizeInMb: number; allowedFileExtensions: string }> {
        return this.documentDataService.GetDocumentConfig();
    }

    getDocumentHistory(documentId: string): Observable<any> {
        if (!documentId) {
            return new Observable((observer) => {
                observer.next([]);
                observer.complete();
            });
        }
        return this.httpClient.get<any>(`${this.baseUrl}/${documentId}/history/`);
    }

    filterAllowedFiles(files: File[] | FileList, allowedExtensions: string): File[] {
        return DocumentMethods.filterAllowedFiles(this.toastrService, files, allowedExtensions);
    }

    validateUploadLimit(files: File[], maxUploadSizeInMb: number): boolean {
        return DocumentMethods.validateUploadLimit(maxUploadSizeInMb, this.toastrService, files);
    }

    openDocumentViewer(documentId: string, documentName: string, pdfSrc?: string): void {
        this._popupService.forceOpenInNewWindow(pdfSrc);
    }
}
